import {flow, get, toNumber} from '@yandex-delivery/utils'
import type {DestinationPoint, RoutePoint, SourcePoint} from 'src/shared/types'
import {getPointId} from 'src/shared/utils'

const getRoutePointId = flow(getPointId, String)
const getRoutePointLon = flow(get('address.coordinates[0]'), toNumber)
const getRoutePointLat = flow(get('address.coordinates[1]'), toNumber)

export const toSourceRouteChangePoint = (point: SourcePoint): RoutePoint => ({
  type: 'source',
  lon: getRoutePointLon(point),
  lat: getRoutePointLat(point),
  id: getRoutePointId(point),
})

export const toDestinationRouteChangePoint = (
  point: DestinationPoint,
): RoutePoint => ({
  type: 'destination',
  lon: getRoutePointLon(point),
  lat: getRoutePointLat(point),
  id: getRoutePointId(point),
})
